import React from 'react';

const WHATSAPP_LINK =
  "https://wa.me/447941222437?text=Hi%2C%20I%27d%20like%20to%20chat";
const GET_STARTED_LINK =
  'mailto:info@heretic-studio.co.uk?subject=Idea%20Accelerator';

const Accelerator = () => {
  return (
    <div className="accelerator-page">
      <section className="section accelerator-hero">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-12">
              <h1 className="accelerator-title">Turn your idea into an MVP</h1>
              <h2 className="accelerator-subtitle">
                A focused accelerator to move from concept to a shippable product—fast.
              </h2>

              <div className="accelerator-cta">
                <a className="accelerator-btn" href={WHATSAPP_LINK} target="_blank" rel="noreferrer">
                  Chat on WhatsApp
                </a>
                <a className="accelerator-btn primary" href={GET_STARTED_LINK}>
                  Get started now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section accelerator-section">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-3">
              <span className="mono">What it is</span>
            </div>
            <div className="col-2" />
            <div className="col-7">
              <p className="mono accelerator-lede">
                A short, practical sprint designed to remove guesswork: clarify the problem, validate the
                direction, design the experience, and ship an MVP you can learn from.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="accelerator-grid">
                <div className="accelerator-card">
                  <div className="mono accelerator-card__kicker">Step 01</div>
                  <div className="mono accelerator-card__title">Define</div>
                  <div className="mono accelerator-card__body">
                    Align on audience, problem, positioning, and the smallest product that proves value.
                  </div>
                </div>
                <div className="accelerator-card">
                  <div className="mono accelerator-card__kicker">Step 02</div>
                  <div className="mono accelerator-card__title">Design</div>
                  <div className="mono accelerator-card__body">
                    Map flows, prototype quickly, and build a UI system that’s ready to scale.
                  </div>
                </div>
                <div className="accelerator-card">
                  <div className="mono accelerator-card__kicker">Step 03</div>
                  <div className="mono accelerator-card__title">Ship</div>
                  <div className="mono accelerator-card__body">
                    Launch an MVP with clear analytics-ready flows so you can learn and iterate.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section accelerator-section">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-3">
              <span className="mono">What you get</span>
            </div>
            <div className="col-2" />
            <div className="col-7">
              <ul className="accelerator-list mono">
                <li>Product direction + scope (what to build first, and why)</li>
                <li>User flows + information architecture</li>
                <li>Clickable prototype for validation and pitching</li>
                <li>UI kit / design system foundations</li>
                <li>Shippable MVP build plan (Stripe can be integrated later)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section accelerator-section">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-3">
              <span className="mono">Who it’s for</span>
            </div>
            <div className="col-2" />
            <div className="col-7">
              <ul className="accelerator-list mono">
                <li>Founders with an idea and no product yet</li>
                <li>Teams stuck in scope creep or decision paralysis</li>
                <li>Startups needing a faster path to validation</li>
                <li>Operators launching a new venture or internal product</li>
              </ul>
            </div>
          </div>

          <div className="row" style={{ marginTop: '2rem' }}>
            <div className="col-12">
              <div className="accelerator-cta">
                <a className="accelerator-btn" href={WHATSAPP_LINK} target="_blank" rel="noreferrer">
                  Chat on WhatsApp
                </a>
                <a className="accelerator-btn primary" href={GET_STARTED_LINK}>
                  Get started now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Accelerator;
